import SethL from '../../images/SethLI2P.jpg';
import SethLROOF from '../../images/SethLROOFI2P.jpg';

function ContactContent() {
  return (
    <div className = 'contact-content-content'>
      <span className = 'contact-content-content-subtitle'>Contact</span>
      <span className = 'contact-content-content-title'>REACH OUT TO ME</span>

      <img src = {SethLROOF} className = 'contact-content-content-img' />

      <span className = 'contact-content-content-address'>slprogram2005@gmail.com</span>
      <div className = "contact-content-content-buttons">
        <button onClick={()=>{window.open("https://twitter.com/SethTML05","_blank")}}  className = "contact-content-content-buttons-button">TWITTER</button>
        <button onClick={()=>{window.open("https://www.linkedin.com/in/sethlamar/","_blank")}}  className = "contact-content-content-buttons-button">LINKEDIN</button>
      </div>
    </div>
  );
}


export default ContactContent;